<template>
  <layout>
    <div class="page-view">
      <banner
        :title="pageData.menuName"
        subtitle="SHOUHOUCHAXUN"
        :filter="true"
        img="https://oss.jingshucloud.com/gw-bucket/17798120-0e0b-4041-91bd-5364e86e15fd.png" />
      <div class="about">
        <f-title
          :title="menuModule[0]?.title"
          :subtitle="menuModule[0]?.titleEn" />
        <div
          class="about-cont"
          v-for="d in menuModule[0]?.detailsList"
          :key="d.id">
          <div class="about-cont-kv">
            <van-image
              width="100%"
              lazy-load
              :src="d.imgUrl" />
          </div>
          <div class="about-cont-desc">
            {{ d.imgContent }}
            <div
              class="about-cont-more"
              @click="knowClick('7-1', contList.menuModule[0])">
              了解更多<span class="iconfont icon-right-1-copy"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="team">
        <f-title
          :title="menuModule[1]?.title"
          :subtitle="menuModule[1]?.titleEn" />
        <swiper
          v-if="menuModule[1]?.detailsList !== undefined"
          class="phone-hidden"
          :options="swiperOptions">
          <swiper-slide
            data-path="/aboutUs/teamDetails"
            data-plate="team"
            :data-menuModule="1"
            :data-index="index"
            class="team-item"
            v-for="(item, index) in teamItems"
            :key="index">
            <img
              class="avatar"
              :src="item"
              alt="" />
            <!-- <div class="cont">
              <div class="cont-name">{{ item.title }}</div>
              <div class="cont-posts">{{ item.imgContent }}</div>
            </div> -->
          </swiper-slide>
          <div
            class="swiper-pagination1"
            slot="pagination"></div>
        </swiper>
        <swiper
          class="ipad-hidden"
          v-if="menuModule[1]?.detailsList !== undefined"
          :options="swiperOptions1">
          <swiper-slide
            data-path="/aboutUs/teamDetails"
            data-plate="team"
            :data-menuModule="1"
            :data-index="index"
            class="team-item"
            v-for="(item, index) in teamItems"
            :key="index">
            <img
              class="avatar"
              :src="item"
              alt="" />
            <!-- <div class="cont">
              <div class="cont-name">{{ item.title }}</div>
              <div class="cont-posts">{{ item.imgContent }}</div>
            </div> -->
          </swiper-slide>
          <div
            class="swiper-pagination2"
            slot="pagination"></div>
        </swiper>
      </div>
      <div class="welfare">
        <f-title
          :title="menuModule[2]?.title"
          :subtitle="menuModule[2]?.titleEn" />
        <van-swipe
          class="my-swipe phone-hidden"
          :autoplay="3000"
          indicator-color="white">
          <van-swipe-item
            v-for="(item, index) in menuModule[2]?.detailsList"
            @click.native="
              toPage(
                '/aboutUs/corporateWelfare',
                item,
                'welfare',
                menuModule[2]
              )
            "
            :key="index">
            <img
              :src="item.imgUrl"
              alt="" />
          </van-swipe-item>
        </van-swipe>
        <swiper
          v-if="menuModule[2]?.detailsList !== undefined"
          class="ipad-hidden"
          :options="swiperOptions2">
          <swiper-slide
            data-path="/aboutUs/corporateWelfare"
            data-plate="welfare"
            :data-menuModule="2"
            :data-index="index"
            class=""
            v-for="(item, index) in menuModule[2]?.detailsList"
            :key="index">
            <img
              :src="item.imgUrl"
              alt="" />
          </swiper-slide>
          <div
            class="swiper-pagination3"
            slot="pagination"></div>
        </swiper>
      </div>
      <div class="cooperate">
        <f-title
          :title="menuModule[3]?.title"
          :subtitle="menuModule[3]?.titleEn" />
        <div class="cooperate-kv">
          <img
            :src="menuModule[3]?.detailsList[0]?.imgUrl"
            alt="" />
        </div>
        <div class="cont">
          <div class="cont-title">
            {{ menuModule[3]?.detailsList[0]?.title }}
          </div>
          <div class="cont-desc">
            {{ menuModule[3]?.detailsList[0]?.content }}
          </div>
          <div
            class="cont-more"
            @click="knowClick('7-4', menuModule[3])">
            成为合作伙伴<span class="iconfont icon-right-1-copy"></span>
          </div>
        </div>
      </div>
      <div class="recruit">
        <f-title
          :title="menuModule[4]?.title"
          :subtitle="menuModule[4]?.titleEn" />
        <div class="recruit-bg">
          <img
            :src="menuModule[4]?.detailsList[0]?.imgUrl"
            alt="" />
          <div class="cont">
            <div class="cont-title">
              {{ menuModule[4]?.detailsList[0]?.title }}
            </div>
            <div
              class="cont-more"
              @click="knowClick('7-5', contList.menuModule[4])">
              了解更多
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import { getCategoryInfo } from '@/api/index';
import { toPage } from '@/utils/tool';
import Layout from '@/components/moblie/Layout.vue';
import Banner from '@/components/banner.vue';
import FTitle from '@/components/title.vue';
export default {
  components: { Layout, Banner, FTitle },
  data() {
    var that = this;
    return {
      pageData: {},
      menuModule: [],
      swiperOptions: {
        // 设置每屏显示的滑块数
        slidesPerView: 3,
        slidesPerGroup: 3, // 每次滑动3个滑块，保持对齐
        spaceBetween: 12, // 滑块之间的间隔为12px
        // 启用分页器
        pagination: {
          el: '.swiper-pagination1',
        },
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // on: {
        //   click: function () {
        //     console.log(this.clickedSlide.dataset);
        //     var { index, menumodule, path, plate } = this.clickedSlide.dataset;
        //     that.toPage(
        //       path,
        //       that.menuModule[menumodule].detailsList[index],
        //       plate,
        //       that.menuModule[menumodule],
        //       index
        //     );
        //   },
        // },
      },
      teamItems: [
        require('@/assets/images/team/1.png'),
        require('@/assets/images/team/2.png'),
        require('@/assets/images/team/3.png'),
        require('@/assets/images/team/4.png'),
        require('@/assets/images/team/5.png'),
        require('@/assets/images/team/8.png'),
        require('@/assets/images/team/9.png')
      ],
      swiperOptions1: {
        // 设置每屏显示的滑块数
        slidesPerView: 4,
        spaceBetween: 12, // 滑块之间的间隔为12px
        grabCursor: true,
        loopedSlides: 4,
        loop: true,
        autoplay: {
          delay: 3000,
        },
        // on: {
        //   click: function () {
        //     console.log(this.clickedSlide.dataset);
        //     var { index, menumodule, path, plate } = this.clickedSlide.dataset;
        //     that.toPage(
        //       path,
        //       that.menuModule[menumodule].detailsList[index],
        //       plate,
        //       that.menuModule[menumodule],
        //       index
        //     );
        //   },
        // },
      },
      swiperOptions2: {
        effect: 'coverflow',
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -20,
          depth: 60,
          modifier: 2,
          slideShadows: false,
        },
        pagination: {
          el: '.swiper-pagination3',
        },
        autoplay: {
          delay: 3000,
        },
        on: {
          click: function () {
            console.log(this.clickedSlide.dataset);
            var { index, menumodule, path, plate } = this.clickedSlide.dataset;
            that.toPage(
              path,
              that.menuModule[menumodule].detailsList[index],
              plate,
              that.menuModule[menumodule]
            );
          },
        },
      },
    };
  },
  created() {
    this.getCategoryInfo();
  },
  methods: {
    knowClick(row, txt) {
      if (row == '7-1') {
        this.$router.push({
          name: 'aboutUs/companyIntro',
          params: { txt: txt },
        });
      }
      if (row == '7-4') {
        this.$router.push({
          name: 'aboutJingshu/partnerIndex',
          params: { txt: txt },
        });
      }
      if (row == '7-5') {
        this.$router.push({
          name: 'aboutJingshu/recruitment',
          params: { txt: txt },
        });
      }

      this.$store.commit('changeTabCheck', {
        idNum: row,
        sumName: '',
      });
      this.$store.state.enterp_somFlg = '';
    },
    getCategoryInfo() {
      getCategoryInfo(34).then((res) => {
        var { data } = res;
        this.pageData = data.data;
        this.menuModule = data.data.menuModule;
      });
    },
    toPage(path, data, plate, module, id) {
      if (plate === 'team') {
        localStorage.setItem('teamId', id);
        localStorage.setItem('teamInfo', JSON.stringify(module.detailsList));
      }
      if (plate) {
        localStorage.setItem(
          plate + 'MenuModule',
          JSON.stringify({ data, module })
        );
      }
      toPage(path);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
/* phone */
@media (max-width: $phone-max-size) {
  $container-width: 336px;
  .page-view {
    .about {
      width: $container-width;
      margin: 30px auto;
      &-cont {
        &-kv {
          width: 100%;
          margin-bottom: 10px;
        }
        &-desc {
          font-weight: 400;
          font-size: 10px;
          color: #666666;
          line-height: 14px;
          margin-bottom: 4px;
        }
        &-more {
          font-weight: 500;
          font-size: 11px;
          color: #04758e;
          line-height: 13px;
          text-align: right;
          .iconfont {
            font-size: 11px;
            line-height: 13px;
          }
        }
      }
    }
    .team {
      width: $container-width;
      margin: 0 auto 30px;
      &-item {
        position: relative;
        .avatar {
          width: 100%;

        }
        .cont {
          position: absolute;
          bottom: 0;
          left: 0;
          padding: 5px;
          width: 100%;
          background-color: rgba($color: #000000, $alpha: 0.4);
          &-name {
            font-weight: 600;
            font-size: 12px;
            color: #ffffff;
            line-height: 14px;
          }
          &-posts {
            font-weight: 300;
            font-size: 9px;
            color: #ffffff;
            line-height: 11px;
          }
        }
      }
    }
    .welfare {
      width: $container-width;
      margin: 0 auto 30px;
      img {
        width: 100%;
        height: 160px;
        object-fit: cover;
      }
    }
    .cooperate {
      width: $container-width;
      margin: 0 auto 30px;
      &-kv {
        img {
          width: 100%;
        }
        margin-bottom: 10px;
      }
      .cont {
        &-desc {
          font-weight: 400;
          font-size: 9px;
          color: #666666;
          line-height: 14px;
          margin-bottom: 8px;
        }
        &-more {
          font-weight: 500;
          font-size: 9px;
          color: #04758e;
          text-align: right;
          .iconfont {
            font-size: 9px;
          }
        }
      }
    }
    .recruit {
      width: 100%;
      margin: auto;
      &-bg {
        height: 165px;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba($color: #000000, $alpha: 0.6);
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .cont {
          position: absolute;
          z-index: 2;
          left: 25px;
          top: 50%;
          transform: translateY(-50%);
          &-title {
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            line-height: 16px;
            margin-bottom: 25px;
          }
          &-more {
            text-align: center;
            font-weight: 400;
            font-size: 11px;
            display: inline-block;
            color: #ffffff;
            line-height: 13px;
            padding: 6px 17px;
            border: 1px solid #ffffff;
            &:active {
              transform: scale(0.98);
            }
          }
        }
      }
    }
  }
}
/* ipad */
@media (min-width: $ipad-min-size) and (max-width: $ipad-max-size) {
  $container-width: 700px;
  .page-view {
    .about {
      width: $container-width;
      margin: 30px auto;
      &-cont {
        display: flex;
        align-items: center;
        &-kv {
          width: 312px;
          margin-bottom: 10px;
          flex-shrink: 0;
          margin-right: 25px;
        }
        &-desc {
          font-weight: 400;
          font-size: 13px;
          color: #666666;
          margin-bottom: 14px;
        }
        &-more {
          font-weight: 500;
          font-size: 13px;
          color: #04758e;
          text-align: right;
          .iconfont {
            font-size: 13px;
          }
        }
      }
    }
    .team {
      width: $container-width;
      margin: 0 auto 30px;
      &-item {
        position: relative;
        .avatar {
          width: 100%;
        }
        .cont {
          position: absolute;
          bottom: 0;
          left: 0;
          padding: 5px;
          width: 100%;
          background-color: rgba($color: #000000, $alpha: 0.4);
          &-name {
            font-weight: 600;
            font-size: 14px;
            color: #ffffff;
          }
          &-posts {
            font-weight: 300;
            font-size: 12px;
            color: #ffffff;
          }
        }
      }
    }
    .welfare {
      width: $container-width;
      margin: 0 auto 30px;
      img {
        width: 100%;
        height: 160px;
        object-fit: cover;
      }
    }
    .cooperate {
      width: $container-width;
      margin: 0 auto 30px;
      box-shadow: 0px 0 21px 0px rgba(0, 0, 0, 0.06);
      &-kv {
        img {
          width: 100%;
        }
        margin-bottom: 10px;
      }
      .cont {
        padding: 29px 24px;
        &-title {
          font-weight: bold;
          font-size: 17px;
          color: #151a23;
          margin-bottom: 10px;
        }
        &-desc {
          font-weight: 400;
          font-size: 13px;
          color: #666666;
          line-height: 24px;
          margin-bottom: 8px;
        }
        &-more {
          font-weight: 500;
          font-size: 11px;
          color: #04758e;
          line-height: 13px;
          text-align: right;
          .iconfont {
            font-size: 11px;
            line-height: 13px;
          }
        }
      }
    }
    .recruit {
      width: 100%;
      margin: auto;
      &-bg {
        height: 200px;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba($color: #000000, $alpha: 0.6);
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .cont {
          position: absolute;
          z-index: 2;
          left: 72px;
          top: 50%;
          transform: translateY(-50%);
          &-title {
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            line-height: 16px;
            margin-bottom: 25px;
          }
          &-more {
            text-align: center;
            font-weight: 400;
            font-size: 11px;
            display: inline-block;
            color: #ffffff;
            line-height: 13px;
            padding: 6px 17px;
            border: 1px solid #ffffff;
            &:active {
              transform: scale(0.98);
            }
          }
        }
      }
    }
  }
}
.swiper-pagination1,
.swiper-pagination2,
.swiper-pagination3 {
  position: relative;
  margin-top: 20px;
  text-align: center;
}
</style>
